import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './en.json';
import fr from './fr.json';
import tr from './tr.json';
import de from './de.json';
import it from './it.json';
import es from './es.json';
import pl from './pl.json';
import cz from './cz.json';
import hu from './hu.json';


i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    // the translations
    // (tip move them in a JSON file and import them,
    // or even better, manage them via a UI: https://react.i18next.com/guides/multiple-translation-files#manage-your-translations-with-a-management-gui)
    resources: {
      en: {
        translation: en,
      },
      hu: {
        translation: hu,
      },
      cz: {
        translation: cz,
      },
      fr: {
        translation: fr,
      },
      tr: {
        translation: tr,
      },
      de: {
        translation: de,
      },
      it: {
        translation: it,
      },
      es: {
        translation: es,
      },
      pl: {
        translation: pl,
      },
    },
    lng: localStorage.getItem('i18nextLng') || 'en', // if you're using a language detector, do not define the lng option
    fallbackLng: 'en',

    interpolation: {
      escapeValue: false, // react already safes from xss => https://www.i18next.com/translation-function/interpolation#unescape
    },
  });
